<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="module__background about__background"
        >
        </app-modulebackground>
        <div
            class="about__container module__container"
            v-bind:class="{
                container__fluid: [4, 5].includes(module.layout.type),
                container__boxed: [1, 2, 3].includes(module.layout.type)
            }"
        >
            <div
                class="about__inner module__inner"
                v-bind:class="{ 'module__inner--two-cols': [2, 3].includes(module.layout.type) }"
            >
                <div
                    class="about__inner--main module__inner--main"
                    v-bind:class="{ 'bg-color': [4, 5].includes(module.layout.type) }"
                >
                    <div
                        class="about__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="about__inner-col module__inner-col">
                            <div class="about__header module__header">
                                <h2
                                    class="about__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="about__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="about__inner-row module__inner-row" v-if="module.data.text">
                        <div class="about__inner-col module__inner-col">
                            <div
                                class="about__text module__text font-p color-p module__cms"
                                v-if="module.data.text"
                                v-html="module.data.text"
                            ></div>
                        </div>
                    </div>
                </div>

                <div
                    class="about__inner--image module__inner--image"
                    v-if="
                        [2, 3, 4, 5].includes(module.layout.type) &&
                            module.data.image &&
                            module.data.image.id
                    "
                >
                    <app-moduleimage
                        v-if="[2, 3, 4, 5].includes(module.layout.type)"
                        :data="module.data.image"
                        :tag="'div'"
                        :custom-class="'about__moduleimage module__moduleimage'"
                    >
                    </app-moduleimage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {},
    props: {
        module: Object
    },
    mounted() {}
};
</script>
